export default __webpack_public_path__ + "static/media/manrope-bold.d876237f.woff";